import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { LocalCache } from '@nk/caching-lib';
import {
  CompanyCompositeEntity,
  CompanyDetailsEntity,
  CompanyEntity,
  CompanyRoleCompositeEntity,
  CompanyRoleEntity,
  PersonCompanyRoleEntity,
  WithUuid,
} from '@nk/data-entities-lib';

export interface CompanyApiService {
  companyCache: LocalCache<CompanyApiService, (companyIdentifier: string) => Observable<WithUuid<CompanyEntity>>>;
  companyCompositeCache: LocalCache<
    CompanyApiService,
    (
      companyIdentifier: string,
      includeHistoricRolesFlag: boolean,
      naceCodeHierarchyLevel?: number,
    ) => Observable<CompanyCompositeEntity>
  >;
  companyDetailsCache: LocalCache<CompanyApiService, (companyUuid: string) => Observable<CompanyDetailsEntity[]>>;
  companyRoleCache: LocalCache<CompanyApiService, () => Observable<CompanyRoleEntity[]>>;
  personCompanyRoleListByCompanyCache: LocalCache<
    CompanyApiService,
    (companyUuid: string, currentFlag?: boolean) => Observable<PersonCompanyRoleEntity[]>
  >;
  companyRoleCompositeListCache: LocalCache<
    CompanyApiService,
    (orgNrSchema: string, organizationTypeIdentifier: string) => Observable<CompanyRoleCompositeEntity[]>
  >;
  // TODO: add more when needed
}

export const COMPANY_API_SERVICE_TOKEN = new InjectionToken<CompanyApiService>('CompanyApiService');
